var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 22,
    viewBox: "0 0 2 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.65625,
    y1: 0.5,
    x2: 0.656249,
    y2: 21.5,
    stroke: "#CECECE",
    strokeWidth: 1.3125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeIcon);
export default __webpack_public_path__ + "static/media/pipeIcon.ae652087b3b734f38d7b06655f0bc347.svg";
export { ForwardRef as ReactComponent };